// Cart suggestions: native Shopify recommendations crossed over the cart's
// products (3 seeds max), round-robin merge, cart exclusion, recomputed on every
// cart change. Cards come from the Section Rendering API so they are full
// catalogue cards (quick-add included).
(function () {
  var bq = window.bq;
  if (!bq) return;

  function init(root) {
    if (!root || root.dataset.bqSuggestInit) return;
    root.dataset.bqSuggestInit = '1';
    var grid = root.querySelector('[data-bq-suggest-grid]');
    var MAX_CARDS = Number(root.dataset.max) || 4;
    // Locale prefix: a fetch without it answers in the shop's primary language,
    // so every recommendation came back French on /en and /ar.
    var ROOT = bq.root(root);
    var seq = 0;

    // Shimmer skeleton, first load only: no flash on updates, where real cards
    // are already in place.
    function showSkeleton(n) {
      if (grid.querySelector('product-card')) return;
      var html = '';
      for (var i = 0; i < n; i++) {
        html +=
          '<div class="bq-suggest-skel" aria-hidden="true">' +
          '<div class="bq-suggest-skel__img"></div>' +
          '<div class="bq-suggest-skel__line bq-suggest-skel__line--name"></div>' +
          '<div class="bq-suggest-skel__line bq-suggest-skel__line--price"></div>' +
          '</div>';
      }
      grid.innerHTML = html;
      root.hidden = false;
    }

    function paint(parts) {
      grid.innerHTML = parts.join('');
      var cards = grid.children;
      for (var i = 0; i < cards.length; i++) {
        cards[i].style.setProperty('--i', i);
        cards[i].classList.add('bq-suggest-in');
      }
      root.hidden = false;
    }

    // Server-rendered card: the custom elements (product-card, quick-add-component)
    // are already registered on /cart and hydrate on injection.
    function fetchCard(p) {
      var url = (p.url || '').split('?')[0] + '?section_id=bq-suggest-card';
      return fetch(url)
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('product-card');
          return card ? card.outerHTML : null;
        })
        .catch(function () { return null; });
    }

    function rebuild() {
      var mine = ++seq;
      fetch(ROOT + 'cart.js', { headers: { accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (mine !== seq) return null;
          if (!cart.items.length) {
            root.hidden = true;
            return null;
          }
          showSkeleton(MAX_CARDS);
          var inCart = {};
          cart.items.forEach(function (it) { inCart[it.product_id] = true; });
          var seeds = cart.items.slice(0, 3).map(function (it) { return it.product_id; });
          return Promise.all(seeds.map(function (id) {
            return fetch(ROOT + 'recommendations/products.json?product_id=' + id + '&limit=6&intent=related')
              .then(function (r) { return r.ok ? r.json() : { products: [] }; })
              .catch(function () { return { products: [] }; });
          })).then(function (lists) {
            if (mine !== seq) return;
            // Round-robin: one reco from each seed in turn.
            var picked = [];
            var pickedIds = {};
            var rank = 0;
            while (picked.length < MAX_CARDS) {
              var advanced = false;
              for (var i = 0; i < lists.length && picked.length < MAX_CARDS; i++) {
                var p = (lists[i].products || [])[rank];
                if (!p) continue;
                advanced = true;
                if (inCart[p.id] || pickedIds[p.id]) continue;
                pickedIds[p.id] = true;
                picked.push(p);
              }
              if (!advanced) break;
              rank++;
            }
            if (!picked.length) {
              root.hidden = true;
              return;
            }
            return Promise.all(picked.map(fetchCard)).then(function (htmls) {
              if (mine !== seq) return;
              var parts = htmls.filter(Boolean);
              if (!parts.length) {
                root.hidden = true;
                return;
              }
              paint(parts);
            });
          });
        })
        .catch(function () {});
    }

    // Coalesce add bursts into one rebuild; the seq token still guarantees only
    // the latest cart state paints.
    var rebuildTimer = null;
    function scheduleRebuild() {
      if (rebuildTimer) clearTimeout(rebuildTimer);
      rebuildTimer = setTimeout(function () { rebuildTimer = null; rebuild(); }, 250);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rebuild, { once: true });
    } else {
      rebuild();
    }

    document.addEventListener('shopify:cart:lines-update', function onLines(event) {
      // Bound outside the section: a re-render leaves this one behind on a
      // detached root, so it steps aside for the binding of the new one.
      if (!root.isConnected) { document.removeEventListener('shopify:cart:lines-update', onLines); return; }
      // Optimistic event: await the request promise, or the read returns the stale
      // cart. The promise sits on the event, not on `detail` (`detail`
      // is undefined), so reading `detail.promise` always fell back to the timer.
      var p = event && (event.promise || (event.detail && event.detail.promise));
      if (p && typeof p.finally === 'function') p.finally(scheduleRebuild);
      else setTimeout(scheduleRebuild, 400);
    });
  }

  init(document.querySelector('[data-bq-suggest]'));
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-bq-suggest]'));
  });
})();
